import { Component, Inject, OnInit } from "@angular/core";

import { DropDownLink } from "src/app/models/drop-down-link.interface";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DialogData } from "../../pages/activity-booking-page/activity-booking-page.component";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule]
})
export class FooterComponent implements OnInit {
  menuItems: DropDownLink[] = [];
  noResultsMessage!: string;
  displayCategoryMenu!: boolean;
  iconSize: SizeProp = "3x";
  showCompanyInfoForm: boolean = false;
  readonly currentYear = new Date().getFullYear();
  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CompanyInfoDialog, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }
  openEnterCompanyInfo() {
    this.showCompanyInfoForm = true;
  }
}

@Component({
    selector: 'company-info-dialog',
    templateUrl: './company-info-dialog/company-info-dialog.component.html',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule]
})
export class CompanyInfoDialog {
  constructor(
    public dialogRef: MatDialogRef<CompanyInfoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  infoSaved: boolean = false;
  saveBusinessInfoForm = new FormGroup({
    businessName: new FormControl(),
    businessContactName: new FormControl(),
    businessContactEmail: new FormControl(),
    businessDescription: new FormControl(),
  });

  saveInfo(): void {
    // TODO: Implement company info save with Amplify Gen 2
    console.log('Company info submitted:', this.saveBusinessInfoForm.value);
    this.infoSaved = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}